import { lazy } from 'react';
import useTimer from '@/hooks/useTimer';
import Controls from './Controls';

const DisplayProgress = lazy(() => import('./DisplayProgress'));
const DisplayTime = lazy(() => import('./DisplayTime'));

function Timer() {
  const { dispatch, ...state } = useTimer();

  const { initial } = state;
  return (
    <div className="flex flex-col gap-6 grow">
      {!initial && <DisplayProgress state={state} />}
      <Controls dispatch={dispatch} state={state} />
      {!initial && <DisplayTime state={state} />}
    </div>
  );
}

export default Timer;
